import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ccf4110"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-event" }
const _hoisted_2 = { class: "service-event__section wrapper" }
const _hoisted_3 = { class: "service-event__section wrapper service-event__info-and-results" }
const _hoisted_4 = {
  key: 0,
  class: "service-event__results"
}
const _hoisted_5 = {
  key: 2,
  class: "service-event__button-wrapper"
}
const _hoisted_6 = {
  key: 0,
  class: "service-event__section--scrollable service-event__related-services"
}

import {
  useServiceMediaFileQuery,
  useServiceRelatedServicesQuery,
} from '@/queries/public/services'
import PhotoGallery from '@/components/public/PhotoGallery.vue'
import { useOrderStore } from '@/store/order'
import { ref } from 'vue'
import EventResultCard from '@/components/public/EventResultCard.vue'
import MoneyJarResultCard from '@/components/public/MoneyJarResultCard.vue'
import SubmitButton from '@/components/public/SubmitButton.vue'
import RelatedServices from '@/components/public/RelatedServices.vue'
import { FORMATS } from '@/enums/components'
import { useBreakpoints } from '@/composables/useBreakpoints'
import router from '@/router'
import { ROUTE_PATHS } from '@/router/public/paths'
import { storeToRefs } from 'pinia'
import { ServiceType } from '@/enums/services'
import { servicePublicDetailsCommonProps } from '@/enums/public'


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceEvent',
  props: {
  ...servicePublicDetailsCommonProps,
},
  setup(__props) {

const props = __props



const {
  isLoading: isMediaFileLoading,
  isError: isMediaFileError,
  data: serviceMediaFile,
} = useServiceMediaFileQuery(ref(props.serviceId), props.isPreview)

const { data: relatedServices } = useServiceRelatedServicesQuery(
  ref(props.serviceId),
  props.isPreview,
)

const orderStore = useOrderStore()
const { isMobile } = useBreakpoints()
const { order } = storeToRefs(orderStore)

const goToCart = () => {
  router.push({
    name: ROUTE_PATHS.CART,
    params: { uuid: order.value.uuid },
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (
          !_unref(isMediaFileLoading) && !_unref(isMediaFileError) && _unref(serviceMediaFile)?.length
        )
        ? (_openBlock(), _createBlock(PhotoGallery, {
            key: 0,
            photos: _unref(serviceMediaFile)
          }, null, 8, ["photos"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default"),
      (_ctx.enableOrdering)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.service.type === _unref(ServiceType).EVENT)
              ? (_openBlock(), _createBlock(EventResultCard, {
                  key: 0,
                  service: _ctx.service,
                  "is-preview": _ctx.isPreview,
                  referral: _ctx.referral
                }, null, 8, ["service", "is-preview", "referral"]))
              : (_ctx.service.type === _unref(ServiceType).MONEYJAR)
                ? (_openBlock(), _createBlock(MoneyJarResultCard, {
                    key: 1,
                    service: _ctx.service,
                    "is-preview": _ctx.isPreview,
                    referral: _ctx.referral
                  }, null, 8, ["service", "is-preview", "referral"]))
                : _createCommentVNode("", true),
            (_unref(orderStore).isOrderWithItems && !_ctx.isPreview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(SubmitButton, {
                    format: _unref(FORMATS).PRIMARY,
                    label: _ctx.$t('goToCart'),
                    icon: "arrow-right",
                    "icon-right": true,
                    class: _normalizeClass(
              _unref(isMobile)
                ? 'service-page__button'
                : 'service-page__button--desktop'
            ),
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => goToCart(), ["prevent"]))
                  }, null, 8, ["format", "label", "class"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (!props.hideRelated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_unref(relatedServices)?.length)
            ? (_openBlock(), _createBlock(RelatedServices, {
                key: 0,
                title: _ctx.$t('relatedServices.heading'),
                services: _unref(relatedServices),
                "is-preview": _ctx.isPreview,
                referral: {
          referral_type: 's',
          referral_code: _ctx.service.hash_id,
        }
              }, null, 8, ["title", "services", "is-preview", "referral"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})